// Kept apart from actions/privateChat so models can dispatch it without
// importing the private chat holder and everything behind it.
export const PRIVATE_CHAT_PARTNER_PRESENCE_CHANGED = 'PRIVATE_CHAT_PARTNER_PRESENCE_CHANGED';

/** A DM partner's online status changed: the DM list redraws its dots. */
export const privateChatPartnerPresenceChanged = () => ({
	type: PRIVATE_CHAT_PARTNER_PRESENCE_CHANGED,
});
